import axios from 'axios';

/**
 * Admin Report Service
 * Handles admin-specific reporting API operations
 */
class AdminReportService {
  /**
   * Get all reported projects grouped by project
   */
  async getGroupedReports() {
    try {
      const response = await axios.get('/api/admin/reports');
      return response.data;
    } catch (error) {
      console.error('Get grouped reports error:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Get all reports for a specific project
   */
  async getProjectReports(projectId) {
    try {
      const response = await axios.get(`/api/admin/reports/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Get project reports error:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Dismiss all reports for a project
   */
  async dismissReports(projectId) {
    try {
      const response = await axios.post(`/api/admin/reports/${projectId}/dismiss`);
      return response.data;
    } catch (error) {
      console.error('Dismiss reports error:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors consistently
   */
  handleError(error) {
    if (error.response) {
      const { data } = error.response;
      return {
        message: data.error?.message || 'An error occurred',
        code: data.error?.code || 'API_ERROR',
        status: error.response.status,
      };
    }
    return {
      message: error.message || 'An unexpected error occurred',
      code: 'UNKNOWN_ERROR',
      status: 0,
    };
  }

  /**
   * Get status badge color for reports
   */
  getReportStatusColor(reportCount) {
    if (reportCount >= 5) return 'bg-red-100 text-red-800';
    if (reportCount >= 3) return 'bg-orange-100 text-orange-800';
    return 'bg-yellow-100 text-yellow-800';
  }
}

export default new AdminReportService();
